import React, { useEffect } from 'react'

// Prices and the launch offer (free until 31 March 2028) live on one page, capabble.cloud/pricing,
// which mirrors the billing catalog. This route only sends old links there.
const PRICING_URL = 'https://capabble.cloud/pricing'

const Pricing: React.FC = () => {
  useEffect(() => {
    window.location.replace(PRICING_URL)
  }, [])
  return (
    <p style={{ padding: 24, fontFamily: 'system-ui, sans-serif' }}>
      Opening <a href={PRICING_URL}>Capabble pricing</a>…
    </p>
  )
}

export default Pricing
